<div
  *mobxAutorun
  [ngClass]="{ 'flex-column align-items-center': showGraph }"
  class="flex justify-content-center"
>
  <span *ngIf="loading; else content"
    ><span class="search-spinner"
      ><img src="assets/images/loader.gif" alt="Loading" width="35" height="35" /></span
  ></span>
  <ng-template #content>
    <div [ngClass]="{ 'my-2': showGraph }" class="flex align-items-center">
      <div class="key-metric-value">{{ valueText }}</div>
    </div>
    <div
      *ngIf="showTargetDifference && !showGraph"
      class="flex font-bold align-items-center ml-3 pl-3 border-left-1 border-black-alpha-30"
      [ngClass]="{ 'text-pink-800': targetDifference < 0, 'text-green-700': targetDifference >= 0 }"
    >
      {{ targetText }}
    </div>
    <p-chart
      *ngIf="showGraph"
      [data]="chartData"
      [options]="chartOptions"
      height="220px"
      [width]="isViewportAtLeastMedium ? '32vw' : '80vw'"
      type="bar"
    ></p-chart>
  </ng-template>
</div>
